document.addEventListener('DOMContentLoaded', () => {
  // 1. DOM references
  const buyNowBtn = document.querySelector('.header-buy-now-btn');
  if (!buyNowBtn) return;

  // 2. UI helpers: spinner controls
  const showButtonSpinner = (btn) => {
    const spinner = btn.querySelector('.loading__spinner');
    if (!spinner) return;
    spinner.classList.remove('hidden');
    spinner.setAttribute('aria-hidden', 'false');
  };

  const hideButtonSpinner = (btn) => {
    const spinner = btn.querySelector('.loading__spinner');
    if (!spinner) return;
    spinner.classList.add('hidden');
    spinner.setAttribute('aria-hidden', 'true');
  };

  // 3. UI helpers: button lock/unlock (prevents double click/tap)
  const lockButton = (btn) => {
    btn.dataset.locked = 'true';
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('tabindex', '-1');
    btn.classList.add('is-disabled');
  };

  const unlockButton = (btn) => {
    delete btn.dataset.locked;
    btn.removeAttribute('aria-disabled');
    btn.removeAttribute('tabindex');
    btn.classList.remove('is-disabled');
  };

  // 4. Resolve market-aware checkout URL
  // Reads the subfolder prefix from the current path (e.g. /en-usa)
  // so checkout stays in the correct Shopify market context.
  const getCheckoutUrl = () => {
    const match = window.location.pathname.match(/^(\/[a-z]{2}-[a-z]+)\//);
    const prefix = match ? match[1] : '';
    return prefix + '/checkout';
  };

  // 5. Core action: add variant to cart via Shopify AJAX API
  const addVariantToCart = async ({ id, quantity }) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.description || data?.message || 'Add to cart failed');
    return data;
  };

  // 6. Wire up events: click handler for header Buy Now button
  buyNowBtn.addEventListener('click', async (e) => {
    // 6.1 Prevent default <a> navigation
    e.preventDefault();

    // 6.2 Guard against double click/tap
    if (buyNowBtn.dataset.locked === 'true') return;

    // 6.3 Resolve variant + quantity (static for header CTA)
    // Future-ready: swap to buyNowBtn.dataset.variantId if you add data-variant-id=""
    const variantId = 43003230748761;
    const quantity = 1;

    // 6.4 Enter loading state (a11y + UI)
    lockButton(buyNowBtn);
    buyNowBtn.setAttribute('aria-busy', 'true');
    buyNowBtn.classList.add('is-loading');
    showButtonSpinner(buyNowBtn);

    try {
      // 6.5 Add item to cart
      await addVariantToCart({ id: variantId, quantity });

      // 6.6 Redirect to checkout, preserving market subfolder (/en-usa/checkout etc.)
      window.location.href = getCheckoutUrl();
    } catch (err) {
      console.warn(err?.message || err);

      // 6.7 Error handling: restore button so user can retry
      buyNowBtn.removeAttribute('aria-busy');
      buyNowBtn.classList.remove('is-loading');
      hideButtonSpinner(buyNowBtn);
      unlockButton(buyNowBtn);
    }
  });
});